import { render, staticRenderFns } from "./static_page.vue?vue&type=template&id=be3a3a4a&"
import script from "./static_page.vue?vue&type=script&lang=js&"
export * from "./static_page.vue?vue&type=script&lang=js&"
import style0 from "./static_page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be3a3a4a')) {
      api.createRecord('be3a3a4a', component.options)
    } else {
      api.reload('be3a3a4a', component.options)
    }
    module.hot.accept("./static_page.vue?vue&type=template&id=be3a3a4a&", function () {
      api.rerender('be3a3a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/static_page.vue"
export default component.exports